import {
  MultipleSelectionConfigurator
} from '@bingads-webui-campaign-react/survey-factory-tools';

export const EscWebuiAutomatedAdDeletionSurveyConfig = (options) => {
  const {
    i18n,
  } = options;

  return {
    featureArea: 'EscWebuiAutomatedAdDeletionSurvey',
    style: {
      root: {
        minWidth: 600,
        '@media (max-width: 600px)': {
          minHeight: 320,
          minWidth: 340,
        },
      },
    },
    others: {
      isGlobalModalStyleEnabled: true,
      isThankYouPageEnabled: false,
      isUserInitiatedSurvey: true,
      combineTextInputToComment: true,
      isInPageMiddle: true,
    },
    questions: [
      {
        isRequired: false,
        Type: MultipleSelectionConfigurator,
        key: 'q1',
        page: 0,
        position: 0,
        getTitle: () => i18n.getString(_TL_('Please let us know why are you deleting this ad')),
        isVisible: () => true,
        options: [
          {
            key: 'q1o1',
            text: i18n.getString(_TL_('Ad is not relevant to my business')),
          },
          {
            key: 'q1o2',
            text: i18n.getString(_TL_('Ad has messaging that I don\'t like')),
          },
          {
            key: 'q1o3',
            text: i18n.getString(_TL_('Ad has offensive content')),
          },
          {
            key: 'q1o4',
            text: i18n.getString(_TL_('Ad has incorrect information')),
          },
          {
            key: 'q1o5',
            text: i18n.getString(_TL_('Ad has specific words that I don\'t like')),
          },
          {
            key: 'q1o6',
            text: i18n.getString(_TL_('Other')),
            placeholder: i18n.getString(_TL_('Other')),
            hasInput: true,
            maxLength: 2000,
          },
        ],
        data: {
        },
      },
    ],
  };
};
